export const GENDERS = [
  { value: "male", label: "Homme" },
  { value: "female", label: "Femme" }
];
